<script>
    import ModalEdit from '../../../layouts/ModalEdit.vue';
    import componentStock from "../../../components/Stock.vue";
    import OrderService from "./OrderService";

    export default {
        components:{
            componentStock
        },
        extends: ModalEdit,
        name: 'modal',
        props: ['value'],
        data: function () {
            return {
                config: null,
                internalValue: '',
                defaultOrderStatus: 'none',
                defaultPaymentStatus: 'none',
                order_statuses: [
                  {id: 'none', name: 'Ne rien toucher'},
                  {id: 'pending', name: 'En attente'},
                  {id: 'in_progress', name: 'En traitement'},
                  {id: 'terminated', name: 'Terminé'},
                  {id: 'shipped', name: 'Envoyé'},
                  {id: 'delivered', name: 'Retrait'}
                ],
                payment_statuses: [
                  {id: 'none', name: 'Ne rien toucher'},
                  {id: 'pending', name: 'En attente'},
                  {id: 'completed', name: 'Payé'},
                ]
            }
        },
        mounted: function(){
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            close() {
                this.$emit('close');
            },
            validate(){
                this.$emit('validate');
            },
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    };
</script>
<template>
    <transition name="modal-fade">
        <div class="modal-backdrop full">
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <article>
                    <header
                            class="modal-header"
                            id="modalTitle">
                        <figure><i class="icon icon-icon_file-edit"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Order <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>Status</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="validate()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>
                    <main class="modal-changes-status">

                      <div style="padding: 40px;">

                      <fieldset>
                        <h3>Modification des statuts</h3>
                        <p class="headline"></p>

                        <form-toggle label="Notifier les clients" v-model="internalValue.data.has_notification"></form-toggle>
                        <form-select label="Statut de paiement" multiple="false" v-model="internalValue.data.payment_status" :default="defaultPaymentStatus" :options="payment_statuses"></form-select>
                        <form-select label="Statut de commandes" multiple="false" v-model="internalValue.data.order_status" :default="defaultOrderStatus" :options="order_statuses"></form-select>

                      </fieldset>

                      </div>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>



// WEBPACK FOOTER //
// src/modules/shop/order/Modal.vue